import config from '../../config.js';

export class OrangeMoneyShopsCtrl {
    constructor($scope, $location, $window, storeServ, shopTypesServ) {
        this.$scope = $scope;
        this.$location = $location;
        this.$window = $window;
        this.storeServ = storeServ;
        this.shopTypesServ = shopTypesServ;
        this.geolocateOnMapReady = true;
        this.config = config;
        this.storeServ.dispatch({
            type: 'SET_SHOP_TYPE',
            shopType: {
                context: this.shopTypesServ.getContextOrangeMoney(),
                typeFilters: [
                    this.shopTypesServ.getTypeShop(),
                    this.shopTypesServ.getTypeStore(),
                    this.shopTypesServ.getTypeSmartStore(),
                    this.shopTypesServ.getTypeStrategic(),
                    this.shopTypesServ.getTypeDealer()
                ],
                subTypeFilters: []
            }
        });
        this.$window.addEventListener('message', this.receivedMessage.bind(this));
    }

    receivedMessage(event) {
        if (this.validateOrigin(event) && this.validateEventData(event.data)) {
            this.storeServ.dispatch({
                type: 'SET_SHOP_TYPE',
                shopType: this.generateShopTypeByEventData(event.data)
            });
        }
    }

    generateShopTypeByEventData(eventData) {
        const shopTpe = {
            context: this.shopTypesServ.getContextOrangeMoney(),
            typeFilters: [],
            subTypeFilters: []
        };
        switch (eventData) {
            case this.shopTypesServ.getTypeShop():
                return Object.assign({}, shopTpe, {
                    typeFilters: [
                        this.shopTypesServ.getTypeShop(),
                        this.shopTypesServ.getTypeStore(),
                        this.shopTypesServ.getTypeSmartStore(),
                        this.shopTypesServ.getTypeStrategic(),
                        this.shopTypesServ.getTypeDealer()
                    ]
                });
            case this.shopTypesServ.getTypeOmMerchant():
                return Object.assign({}, shopTpe, {
                    typeFilters: [this.shopTypesServ.getTypeOmMerchant()]
                });
            case this.shopTypesServ.getSubTypeFashion():
                return Object.assign({}, shopTpe, {
                    typeFilters: [this.shopTypesServ.getTypeOmMerchant()],
                    subTypeFilters: [this.shopTypesServ.getSubTypeFashion()]
                });
            case this.shopTypesServ.getSubTypeSupermarket():
                return Object.assign({}, shopTpe, {
                    typeFilters: [this.shopTypesServ.getTypeOmMerchant()],
                    subTypeFilters: [this.shopTypesServ.getSubTypeSupermarket()]
                });
            case this.shopTypesServ.getSubTypeRestaurants():
                return Object.assign({}, shopTpe, {
                    typeFilters: [this.shopTypesServ.getTypeOmMerchant()],
                    subTypeFilters: [this.shopTypesServ.getSubTypeRestaurants()]
                });
            case this.shopTypesServ.getSubTypeFreeTime():
                return Object.assign({}, shopTpe, {
                    typeFilters: [this.shopTypesServ.getTypeOmMerchant()],
                    subTypeFilters: [this.shopTypesServ.getSubTypeFreeTime()]
                });
            case this.shopTypesServ.getSubTypeHealth():
                return Object.assign({}, shopTpe, {
                    typeFilters: [this.shopTypesServ.getTypeOmMerchant()],
                    subTypeFilters: [this.shopTypesServ.getSubTypeHealth()]
                });
            case this.shopTypesServ.getSubTypeServices():
                return Object.assign({}, shopTpe, {
                    typeFilters: [this.shopTypesServ.getTypeOmMerchant()],
                    subTypeFilters: [this.shopTypesServ.getSubTypeServices()]
                });
            case this.shopTypesServ.getSubTypeElectronics():
                return Object.assign({}, shopTpe, {
                    typeFilters: [this.shopTypesServ.getTypeOmMerchant()],
                    subTypeFilters: [this.shopTypesServ.getSubTypeElectronics()]
                });
            case this.shopTypesServ.getSubTypeMarket():
                return Object.assign({}, shopTpe, {
                    typeFilters: [this.shopTypesServ.getTypeOmMerchant()],
                    subTypeFilters: [this.shopTypesServ.getSubTypeMarket()]
                });
            default:
                return shopTpe;
        }
    }

    validateOrigin(event) {
        return event.origin === this.config.iframeParentHost;
    }

    validateEventData(eventData) {
        return this.shopTypesServ.getTypesAndSubTypes().indexOf(eventData) > -1;
    }
}

OrangeMoneyShopsCtrl.$inject = ['$scope', '$location', '$window', 'storeServ', 'shopTypesServ'];

export default OrangeMoneyShopsCtrl;